(() => {
  document.addEventListener('click', event => {
    document.querySelectorAll('.ct-shop-menu[open]').forEach(menu => {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
    if (event.target.closest('.ct-shop-submenu a')) {
      const mobile = event.target.closest('[data-mobile-menu]');
      if (mobile) mobile.open = false;
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest('.ct-shop-menu[open]');
    if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
  });
})();
